import { html } from "lit-element";

export const CardStyles = html`
<style>
    .card,
    :host(.card) {
        color: #757575;
        border-radius: 2px;
        background-color: var(--primary-color-variant1);
        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
        display: table;
        position: relative;
        table-layout: fixed;
        width: 100%;
        height: fit-content;
    }

    .card > *,
    :host(.card) > * {
        padding: 16px;
    }

    .h {
        background-color: transparent;
        color: var(--secondary-color);
        font-size: x-large;
        display: flex;
        justify-content: space-between;
    }

    .h svg {
        fill: var(--secondary-color);
        align-self: center;
    }

    .h-image {
        padding: 0;
        height: inherit;
    }

    .c {
        display: grid;
        grid-gap: 12px;
        grid-template-columns: calc(50% - 6px) calc(50% - 6px);
        grid-auto-flow: dense;
        box-sizing: border-box;
    }

    .c > text-box[type="multiline"] {
        grid-column-start: 1;
        grid-column-end: span 2;
    }

    .f {
        position: relative;
        height: auto;
        display: grid;
        grid-gap: 12px;
        grid-template-columns: calc(50% - 6px) calc(50% - 6px);
    }

    .info {
        display: flex;
        font-size: small;
        justify-content: space-between;
        color: var(--secondary-color);
    }

    @media only screen and (max-width: 460px) {
        .card > *,
        :host(.card) > * {
            padding-left: 8px;
            padding-right: 8px;
        }

        .h-image {
            padding: 0;
        }

        .c,
        .f {
            display: flex;
            flex-direction: column;
            margin: 0px;
        }

        .c > * {
            margin-bottom: 12px;
        }
    }
</style>`;
